/* Karta produktu v2 (SPEC kap. 2.5): na dotykových zařízeních otevře pilulka „Přínosy“ panel přínosů,
   druhé klepnutí, klepnutí mimo panel nebo Esc ho zavře. Na jemném ukazateli řeší panel jen CSS (:hover). */
(() => {
  if (window.NLCardBenefits) return;
  window.NLCardBenefits = true;

  const OPEN = 'is-benefits-open';

  const setOpen = (card, open) => {
    card.classList.toggle(OPEN, open);
    const btn = card.querySelector('[data-card-benefits]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const openCards = () => Array.from(document.querySelectorAll('.nl-card.' + OPEN));

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const btn = target.closest('[data-card-benefits]');
      if (btn) {
        event.preventDefault();
        event.stopPropagation();
        const card = btn.closest('.nl-card');
        if (!card) return;
        const willOpen = !card.classList.contains(OPEN);
        openCards().forEach((c) => {
          if (c !== card) setOpen(c, false);
        });
        setOpen(card, willOpen);
        return;
      }

      const open = openCards();
      if (!open.length) return;
      if (target.closest('[data-card-panel] a, .nl-card__atc')) return;
      open.forEach((c) => setOpen(c, false));
      /* První klepnutí mimo panel jen zavře, neotevře detail produktu */
      if (target.closest('.nl-card__link, .nl-card__media')) event.preventDefault();
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    openCards().forEach((c) => {
      setOpen(c, false);
      const btn = c.querySelector('[data-card-benefits]');
      if (btn && c.contains(document.activeElement)) btn.focus();
    });
  });
})();
